import store from '@/store';
import {isNotBlank, sleep} from "@/utils";
import router from "@/router";
import {auth} from "@/api/index";

const prefix = '/auth';

export async function loginApi(requestBody) {
	let {data} = await auth.post(prefix + '/login', requestBody);

	let {code: status, body: tokenSet} = data;

	return {status, tokenSet};
}

export async function sessionCheckApi(requestBody) {
	let {data} = await auth.post(prefix + '/session/check', requestBody);

	let {code: status} = data;

	return status;
}

export async function updateApi(requestBody) {
	let {data} = await auth.post(prefix + '/update', requestBody);

	let {code: status} = data;

	return status;
}

export async function refresh() {
	let success = true;
	let {status: refreshStatus, tokenSet} = await refreshApi();

	if(refreshStatus === 'OK') {
		let {accessToken, refreshToken} = tokenSet;
		let requestBody = {accessToken, refreshToken};

		let updateStatus = await updateApi(requestBody);

		if(updateStatus === 'OK'){
			await setToken(accessToken, refreshToken);
		}else if(updateStatus === 'INVALID_TOKEN_SET') {
			alert("요청에 유효하지 않은 토큰이 사용되었습니다.")
			success = false;
		}else if(updateStatus === 'INTERNAL_SERVER_ERROR'){
			alert("일시적인 서버 오류입니다. 잠시후 다시 시도해주세요.")
			success = false;
		}
	}else if(refreshStatus === 'INVALID_SESSION_UUID'){
		alert("새로운 세션에서 로그인하여 로그아웃됩니다.")
		success = false;
	}else if(refreshStatus === 'INTERNAL_SERVER_ERROR'){
		alert("일시적인 서버 오류입니다. 잠시후 다시 시도해주세요.")
		success = false;
	}else {
		alert("인증정보가 만료되어 로그아웃되었습니다.")
		success = false;
	}

	return success;
}

async function refreshApi() {
	let {data} = await auth.get(prefix + '/refresh');

	let {code: status, body: tokenSet} = data;

	return {status, tokenSet};
}

export async function logoutApi() {
	let response = await auth.post(prefix + '/logout');

	await setToken('', '');
	await router.push({path: '/token/logout'});
	await reloadSessionUserData()

	return response;
}

export async function changeSessionUser(requestBody) {
	let success = true;
	let {status: sessionChangeStatus, tokenSet} = await changeSessionUserApi(requestBody);

	if(sessionChangeStatus === 'OK') {
		let {accessToken, refreshToken} = tokenSet;
		let requestBody = {accessToken, refreshToken};

		let updateStatus = await updateApi(requestBody);

		if(updateStatus === 'OK'){
			await setToken(accessToken, refreshToken);
			await router.push({path: '/home'});
			await reloadSessionUserData();
		}else if(updateStatus === 'INVALID_TOKEN_SET') {
			alert("요청에 유효하지 않은 토큰이 사용되었습니다.")
			success = false;
		}else if(updateStatus === 'INTERNAL_SERVER_ERROR'){
			alert("일시적인 서버 오류입니다. 잠시후 다시 시도해주세요.")
			success = false;
		}
	}else if(sessionChangeStatus === 'INTERNAL_SERVER_ERROR'){
		alert("일시적인 서버 오류입니다. 잠시후 다시 시도해주세요.")
		success = false;
	}else {
		alert("인증정보가 만료되어 로그아웃되었습니다.")
		success = false;
	}

	if(!success) {
		await logoutApi();
	}

	return success;
}

export async function changeSessionUserApi(requestBody) {
	let {data} = await auth.post(prefix + '/changeSession', requestBody);

	let {code: status, body: tokenSet} = data;

	return {status, tokenSet};
}

export async function reloadSessionUserData() {
	await sleep(50);
	store.commit('session/setReloadState', true);
	store.commit('menu/setReloadState', true);
	store.commit('menu/resetMenuId');

	return true;
}

export async function setToken(accessToken, refreshToken) {
	store.commit('token/setAccessToken', accessToken);
	store.commit('token/setRefreshToken', refreshToken);

	await sleep(50);
	return true;
}